import React from "react";
import "../About/Aboutus.css";
import About from "./About";
import Details from "../Details/Details";
import Location from "../Location/Location";
const Aboutus = () => {
  return (
    <>
      <img src="form.webp" className="imgg" alt="terrace-image" />
      <About />
      <img src="pan.webp" className="imgg" alt="terrace-image" />
      <Details />
      <Location />
    </>
  );
};

export default Aboutus;
